import { localStorageHandler } from 'core/services';
import { action, observable, makeObservable, runInAction, reaction, toJS } from 'mobx';
import _ from 'lodash';

class BaasicDropdownViewStore {
	@observable value = null;
	@observable isLoading = false;
	@observable options = [];
	staticOptions = [];
	isRequired = false;
	onChangeCallback = null;
	optionOverride = null;
	field = null;
	store = null;
	lookupRoute = null;
	localStorageHandlerKey = null;
	isMulti = false;
	itemTemplate = {
		value: null,
		label: null,
	};
	filter = {
		page: 1,
		rpp: 25,
		orderDirection: 'asc',
	};

	constructor(props, initialize = true) {
		makeObservable(this);
		if (initialize) {
			this.initialize(props);
		}
	}

	@action.bound
	initialize = async ({
		field,
		localStorageHandlerKey,
		store,
		lookupRoute,
		filterProperties,
		onChangeCallback,
		filterCallback,
		optionOverride,
		staticOptions,
		isMulti = false,
		value,
		itemTemplate = {
			value: 'id',
			label: 'name',
		},
		isRequired = false,
	}) => {
		Object.assign(this, {
			field,
			localStorageHandlerKey,
			store,
			lookupRoute,
			onChangeCallback,
			filterCallback,
			optionOverride,
			isMulti,
			staticOptions,
			itemTemplate,
			isRequired,
			value,
		});
		this.filter.orderBy = itemTemplate.label;
		this.filter.searchFields = [itemTemplate.label];
		this.options = staticOptions;
		if (filterProperties != null) {
			Object.assign(this.filter, filterProperties);
		}
		await this.fetchOptions();
		if (field != null) {
			if (field.values() != '') {
				this.value = toJS(field.values());
			}
			reaction(
				() => this.value,
				newValue => {
					this.field.set('value', newValue);
				}
			);
		}
		if (this.localStorageHandlerKey != null) {
			this.setSelectedValue();
		}
	};

	@action.bound
	setSelectedValue = () => {
		const savedValue = localStorageHandler.get(this.localStorageHandlerKey);
		if (savedValue != null) {
			this.value = savedValue;
		}
	};

	@action.bound
	reload = async () => {
		await this.fetchOptions();
		if (this.value != null) {
			if (this.isMulti) {
				this.value = _.filter(this.options, option => {
					const matchingValue = _.find(this.value, value => option.value === value.value);
					return matchingValue !== undefined;
				});
			} else {
				this.value = _.find(this.options, item => {
					return item.value == this.value.value;
				});
			}
			if (this.onChangeCallback && this.value != null) {
				await this.onChangeCallback(this.value, this.field);
			}
		}
	};

	@action.bound
	fetchOptions = async () => {
		if (this.staticOptions == null) {
			if (this.lookupRoute != null) {
				await this.store.find(this.filter, this.lookupRoute);
			} else {
				await this.store.find(this.filter);
			}
			this.options = this.mapResponseToOptions();
		}
	};

	@action.bound
	onChange = async selectedValue => {
		this.value = selectedValue;
		if (this.staticOptions == null) {
			if (this.localStorageHandlerKey != null) {
				localStorageHandler.set(this.localStorageHandlerKey, selectedValue);
			}
			this.resetFilter();
			if (this.options.length > this.filter.rpp) {
				await this.fetchOptions();
			}
		}
		if (this.onChangeCallback != null) {
			await this.onChangeCallback(this.value, this.field);
		}
	};

	@action.bound
	onMenuClose = async () => {
		if (this.filter.search != null) {
			this.isLoading = true;
			this.resetFilter();
			await this.fetchOptions();
			this.isLoading = false;
		}
	};

	@action.bound
	setValue = newValue => {
		this.value = newValue;
		if (this.localStorageHandlerKey != null) {
			localStorageHandler.set(this.localStorageHandlerKey, selectedValue);
		}
	};

	@action.bound
	clear = () => {
		this.value = null;
		if (this.localStorageHandlerKey != null) {
			this.localStorageHandlerKey.clear(this.localStorageHandlerKey);
		}
	};

	onInputChange = _.debounce((searchPhrase, { action }) => {
		if (action === 'input-change') {
			runInAction(async () => {
				if (this.staticOptions == null) {
					this.isLoading = true;
					this.resetFilter();
					this.filter.search = searchPhrase;
					if (this.lookupRoute != null) {
						await this.store.find(this.filter, this.lookupRoute);
					} else {
						await this.store.find(this.filter);
					}
					this.options = this.mapResponseToOptions();
					this.isLoading = false;
				}
			});
		}
	}, 1000);

	@action.bound
	onMenuScrollToBottom = async () => {
		if (this.options.length >= this.filter.rpp && this.staticOptions == null) {
			this.isLoading = true;
			this.filter.page += 1;
			if (this.lookupRoute != null) {
				await this.store.find(this.filter, this.lookupRoute);
			} else {
				await this.store.find(this.filter);
			}
			this.options = this.options.concat(this.mapResponseToOptions());
			this.isLoading = false;
		}
	};

	@action.bound
	resetFilter = () => {
		this.filter.page = 1;
		this.filter.rpp = 25;
		this.filter.search = null;
	};

	@action.bound
	updateFilter = async properties => {
		Object.assign(this.filter, properties);
		await this.reload();
	};

	mapResponseToOptions = () => {
		if (this.filterCallback) {
			return this.filterCallback(this.store.response.item);
		} else {
			const options = _.map(this.store.response.item, item => {
				return {
					value: _.get(item, this.itemTemplate.value),
					label: _.get(item, this.itemTemplate.label),
					extra: item,
				};
			});
			return options;
		}
	};
}

export default BaasicDropdownViewStore;



// WEBPACK FOOTER //
// ./src/common/stores/BaasicDropdownViewStore.js